import React, {useState, useContext, useEffect} from "react";
import {Link, useHistory, Redirect, useParams} from "react-router-dom"
import { UserContext } from "../../App";
import {authenticate, isAuthenticated} from "./helper"

const NewPassword = () => {
    const history = useHistory()
    const [password, setPassword] = useState("")
    const [error, setError] = useState(false)
    const {token1} = useParams()
    console.log(token1)
    const PostData = (e) => {
        // e.preventDefault();
        fetch(`${process.env.REACT_APP_BACKEND}/newpassword`, {
            method:"POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                password,
                token1
            })
        })
        .then(res => res.json())
        .then(data => {
            if(data.error){
                setError(data.error);
            }
            else{
                setError(data.messege)
                history.push("/login")
                // return <Redirect to="/"/>
                
            }
        })
        .catch(err => console.log(err))

    }
    
    const errorMessege = () => (
        <div className="row">
            <div className="col-md-6 offset-sm-3 text-left">
                <div className="alert alert-danger" style={{display: error ? "" : "none"}}>
                    {error}
                </div>
            </div>
        </div>
    )

    

    return (
        <div className="mycard">
        {errorMessege()}
            <div className="card auth-card input-field">
                <h2>SocioRoorkee</h2>
                <input type="password" placeholder="Enter a new Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                <button className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={PostData}>
                    Update Password
                </button>
                
            </div>
            
        </div>
    )
}

export default NewPassword;